type Props = {
  height: string;
  stroke: string;
  width: string;
};
const NewMailIcon = ({ height, stroke, width }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="42"
      viewBox="0 0 41 42"
      fill="none"
    >
      <mask id="path-1-inside-1_1934_57825" fill="white">
        <rect x="3.4165" y="9.0415" width="34.1667" height="25.625" rx="2" />
      </mask>
      <rect
        x="3.4165"
        y="9.0415"
        width="34.1667"
        height="25.625"
        rx="2"
        fill="#4B4B4B"
        stroke="white"
        stroke-width="6"
        mask="url(#path-1-inside-1_1934_57825)"
      />
      <path
        d="M5.125 10.75L19.8861 22.2308C20.2472 22.5117 20.7528 22.5117 21.1139 22.2308L35.875 10.75"
        stroke="white"
        stroke-width="3"
      />

      <circle
        cx="35"
        cy="11"
        r="5"
        fill="#D71225"
        stroke="white"
        stroke-width="2"
      />
    </svg>
  );
};

export default NewMailIcon;
